import React, { Component } from "react";
import { subscribeLoading } from "./loading";
import "./LoadingOverlay.css";

export default class LoadingOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = { visible: false };
  }

  componentDidMount() {
    this.unsubscribe = subscribeLoading((visible) => this.setState({ visible }));
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  render() {
    if (!this.state.visible) {
      return null;
    }

    return (
      <div className="app-loading-overlay" role="status" aria-live="polite">
        <div className="app-loading-box">
          <div className="app-loading-spinner" />
          <div className="app-loading-text">กำลังโหลดข้อมูล...</div>
        </div>
      </div>
    );
  }
}
